import { useState, useEffect, useCallback } from 'react';
import type { Funcionario } from '../types/funcionarios';
import { funcionarioService } from '../services/domain/funcionarioService';

interface UseFuncionarioResult {
  data: Funcionario[];
  loading: boolean;
  error: string | null;
  total: number;
  totalPages: number;
  refetch: () => void;
  search: (searchParams: string) => void,
  updating: boolean;
  creating: boolean;
  searching: boolean;
}

interface FuncionarioParams {
  page?: number;
  area_id?: string;
  name?: string;
  pageSize?: number
}

// interface UserFormResponse {
//     success: boolean,
//     personId: string
// }

export const useFuncionario = (params: FuncionarioParams): UseFuncionarioResult => {
  const [data, setData] = useState<Funcionario[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [updating] = useState(false);
  const [creating] = useState(false);
  const [searching] = useState(false);

  const fetchFuncionario = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await funcionarioService.getList({ page: params.page, area_id: params.area_id || "", name: params.name || ""})
      setData(response.data);
      setTotal(response.pagination.totalItems);
      setTotalPages(response.pagination.totalPages);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      setError(errorMessage);
      console.error('Error fetching funcionarios:', err);
    } finally {
      setLoading(false);
    }
  }, [params.page, params.area_id, params.name]);

  useEffect(() => {
    fetchFuncionario();
  }, [fetchFuncionario]);

  const refetch = useCallback(async () => {
    try {
      fetchFuncionario();
    }
    catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error en actualizar';
      setError(errorMessage);
    }
  }, [fetchFuncionario]);

  const search = useCallback(async (searchTerm: string) => {
    try {
      setLoading(true);
      setError(null);

      const response = await funcionarioService.getList({ name: searchTerm });
      setData(response.data);
      setTotal(response.pagination.totalItems);
      setTotalPages(response.pagination.totalPages);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      setError(errorMessage);
      console.error('Error fetching empleados:', err);
    } finally {
      setLoading(false);
    }
  }, [fetchFuncionario]);

  return {
    data,
    loading,
    error,
    total,
    totalPages,
    refetch,
    search,
    updating,
    creating,
    searching
  };
};